import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../Icon';

import styles from './index.styl';

const imagesTypesList = ['jpg', 'png', 'jpeg'];

const AttachmentItem = ({ data, onDelete }) => {
  const { id, uniqId, type, name, link, extension, category, subcategory } =
    data || {};

  const isImage = imagesTypesList.includes(extension);

  const handleOpenDocument = () => window.open(link);

  return (
    <div className={styles.wrapper}>
      <div className={styles.documentWrapper} onClick={handleOpenDocument}>
        {isImage ? (
          <img className={styles.image} src={link} alt={name} />
        ) : (
          <Icon name="icon-document-black" size={32} className={styles.icon} />
        )}
        <div>
          <div className={styles.fileTitle}>{name}</div>
          <div className={styles.fileCategory}>
            {`${category.name}, ${subcategory.name}`}
          </div>
        </div>
      </div>
      <Icon
        size={16}
        name="remove-member"
        className={styles.removeIcon}
        onClick={() => onDelete({ id, uniqId, type })}
      />
    </div>
  );
};

AttachmentItem.propTypes = {
  data: PropTypes.object,
  onDelete: PropTypes.func,
};

export default memo(AttachmentItem);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/AttachmentItem/index.jsx